import {request} from "./request";

// 获取部门角色列表
export function getAllPosterClassList() {
    return request({
        url: '/hkt/department/get_department_member',
    })
}

// 获取部门列表
export function getDepartment() {
    return request({
        url: '/hkt/department/get_department',
    })
}
// 添加部门
export function addDepartment(name, parent_id) {
    return request({
        url: '/hkt/department/add_department',
        params: {
            name,
            parent_id
        }
    })
}
// 修改部门名称
export function editDepartment(department_id, name) {
    return request({
        url: '/hkt/department/edit_department',
        params: {
            department_id,
            name
        }
    })
}
// 删除部门
export function delDepartment(department_id) {
    return request({
        url: '/hkt/department/del_department',
        params: {
            department_id,
        }
    })
}

// 获取角色列表
export function getRoleList(pagesize, page) {
    return request({
        url: '/hkt/role/get_role_list',
        params: {
            pagesize,
            page
        }
    })
}



// 添加成员 -> 成员列表
export function getStoreMemberList() {
    return request({
        url: '/hkt/member/get_store_member_list',
    })
}

// 添加成员 -> 获取成员信息
export function getStoreMemberInfo(phone) {
    return request({
        url: '/hkt/member/get_store_member_info',
        params: {
            phone,
        }
    })
}

// 添加成员 -> 添加新成员
export function addStoreMember(phone, name, clerk_job, login_role) {
    return request({
        url: '/hkt/member/add_store_member',
        params: {
            phone,
            name,
            clerk_job,
            login_role
        }
    })
}

// 添加成员
export function addMember(role_id, department_id, user_id, user_name, name) {
    return request({
        url: '/hkt/member/add_member',
        params: {
            role_id,
            department_id,
            user_id,
            user_name,
            name
        }
    })
}

// 获取成员列表
export function getMemberDetailedList(pagesize, page, user_name, role_id, department_id) {
    return request({
        url: '/hkt/member/get_member_detailed_list',
        params: {
            pagesize,
            page,
            user_name,
            role_id,
            department_id,
        }
    })
}
// 获取成员列表2
// pagesize	是	int	页码
// user_name	否	string	账号
// role_id	否	int	角色id
// department_id	否	int	部门id
export function getMemberdataList(params) {
    return request({
        url: '/hkt/member/get_member_detailed_list',
        params,
    })
}
// 编辑成员
export function editMember(member_id, role_id, department_id, name) {
    return request({
        url: '/hkt/member/edit_member',
        params: {
            member_id,
            role_id,
            department_id,
            name,
        }
    })
}

// 删除成员
export function delMember(member_id) {
    return request({
        url: '/hkt/member/del_member',
        params: {
            member_id,
        }
    })
}

// 删除成员
export function setDepartmentAdmin(department_id, department_admin) {
    return request({
        url: '/hkt/department/set_department_admin',
        params: {
            department_id,
            department_admin
        }
    })
}


// 同步企微

// 获取企微成员列表
export function getQwUserList() {
    return request({
        url: '/hkt/qwconfig/get_qw_user_list',
        params: {

        }
    })
}
// 导入企微成员
export function importQwMember(userid, is_editname, role_id) {
    return request({
        url: '/hkt/member/import_qw_member',
        params: {
            userid,
            is_editname,
            role_id
        }
    })
}

// 成员信息
export function getMember() {
    return request({
        url: '/hkt/member/get_member',
        params: {

        }
    })
}

// 修改个人信息
export function editMemberInfo(name, head_image, password) {
    return request({
        url: '/hkt/member/edit_member_info',
        params: {
            name,
            head_image,
            password
        }
    })
}
